(function ($) {
    "use strict";

    $.fn.changeElementType = function (newType) {
        var attrs = {};

        $.each(this[0].attributes, function (idx, attr) {
            attrs[attr.nodeName] = attr.nodeValue;
        });

        this.replaceWith(function () {
            return $("<" + newType + "/>", attrs).append($(this).contents());
        });
    };

    $.getSorted = function getSorted(selector, attrName) {
        return $(
            $(selector)
                .toArray()
                .sort(function (a, b) {
                    var aVal = parseInt(a.getAttribute(attrName)),
                        bVal = parseInt(b.getAttribute(attrName));
                    return bVal - aVal;
                })
        );
    };

    $(function () {
        if (($(".js-all-flats").length && $(".t-residential").length)) {
            const residentialId = $(".t-residential").data("project");
            var current_page_id = $(".t-residential").data("id");
            var current_project = $.findObjectByKey(Object.values(localize.residentials), "id", current_page_id);

            if (residentialId) {
                cordiaAPI
                    .get("/sf/getresidentialflatcount", {
                        params: {
                            lang: $.langCookie,
                        },
                    })
                    .then(function (response) {

                        const flatCount = response.data[residentialId];

                        let sum = 0;

                        for (const prop in flatCount) {
                            if (prop != current_project.sp_id && current_project.is_child) {
                                continue;
                            }
                            sum += parseInt(flatCount[prop]);
                        }

                        $(".js-all-flats").text(sum + ` ${localize.translations.flat}`);
                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            }
        }

        if ($('.section__residential').length) {

            cordiaAPI.get('/sf/getfreeflats', {
                params: {
                    lang: $.langCookie
                },
            })
                .then(function (response) {
                    var data = response.data.numbers;
                    var datanames = response.data.names;

                    $('.js-freeflats').each(function () {
                        var residential = $(this).data('residential');
                        var hide = $(this).data('hide');
                        var $parent = $(this).parent();
                        var sum = 0;

                        if (data.hasOwnProperty(residential)) {
                            var projects = $(this).data('projects');
                            var sum = 0;
                            $.each(projects, (index, value) => {
                                if (data[residential][value] != undefined) {

                                    sum += parseInt(data[residential][value]);
                                }
                            });
                        }
                        $(this).css('opacity', '1');
                        
                        if (sum > 0) {
                            if ($.langCookie == 'ru') {
                                $(this).html(`${$.pluralize(localize.translations.freeflats, sum)} ${sum}`);
                            } else {
                                $(this).html(`${sum} ${$.pluralize(localize.translations.freeflats, sum)}`);
                            }
                            if (datanames.hasOwnProperty(residential)) {
                                $(this).attr('href', `${localize.flatSearchUrl}?p=${encodeURIComponent(datanames[residential])}`);
                                $(this).changeElementType("a");
                            }
                            if ($.langCookie == 'hu') {
                                $parent.find('.js-is-badge').show();
                            }
                        } else {
                            if (hide == '1') {
                                $(this).html('');
                            } else {
                                $(this).html(localize.translations.soldout);
                            }

                            $(this).addClass('residential__meta-freeflats--sold-out');
                        }
                    });
                })
                .catch(function (error) {
                    console.log(error);
                });
        }

        $(".js-more-residental").click(function () {
            var $closest_residential = $(this).closest(".section__residential");
            var $residential_list = $closest_residential.find(".residential__list");

            $(this).fadeOut();

            $residential_list.addClass("opened");

            return false;
        });

        $(document).on('click', '.js-residentials-accordion-header', function() {
            var body = $(this).closest('.section-residentials-accordion').find('.section-residentials-accordion__body');
            body.toggleClass('active');
            $(this).toggleClass('active');
            $(this).find('.section-residentials-accordion__header__button span').toggleClass('d-none');
        });
        
    });
})(jQuery);
